<template>
  <div class="streamify-video" v-if="keyy === 0">
    <video ref="video" class="video-js" playsinline></video>
  </div>
</template>

<script>

import Videojs from 'video.js';

export default {
  components: {
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    resetup() {
      this.video.dispose();
      this.keyy = 1;
      this.$nextTick(() => {
        this.keyy = 0;
        this.$nextTick(() => {
          this.setup();
        });
      });
    },
    goto(time) {
      if (!this.video) {
        return;
      }
      this.video.currentTime(time);
    },
    /**
     * Setup the player when its time
     */
    setup() {
      const {
        $refs: {
          // eslint-disable-next-line
          video,
        },
        data,
      } = this;

      const options = {
        ...data,
        html5: {
          vhs: {
            overrideNative: !Videojs.browser.IS_ANY_SAFARI,
          },
        },
      };

      // Boot up videojs
      this.video = Videojs(video, options);

      this.video.reloadSourceOnError({
        errorInterval: 5,
      });

      // Some states
      let firstPlay = true;
      let paused = false;
      let seekTimeout = null;

      // Setup different eventlisteners on video
      this.video.on('ready', () => {
        this.playVideo();

        // Lets try and set last volume
        try {
          this.video.volume(this.$store.getters['Player/volumeSetting']);
        } catch (e) { /* Do nothing */ }

        // Startup a interval that pings every minute
        clearInterval(this.pingInterval);
        this.pingInterval = setInterval(() => {
          if (!this.video.paused() && !this.video.ended()) {
            this.$emit('event', { event: 'ping' });
          }
        }, 60000);
      });
      this.video.on('loadeddata', () => {
        this.$emit('duration', video.duration);
      });
      this.video.on('play', () => {
        // console.log('Videojs play');
        if (firstPlay) {
          firstPlay = false;
          this.$emit('event', { event: 'play' });
          clearInterval(this.timeInterval);
          this.timeInterval = setInterval(() => {
            /*
            if (this.video) {
              clearInterval(this.timeInterval);
            }
            */
            if (!this.video.paused() && !this.video.ended()) {
              this.$store.dispatch('Player/updateCurrentTime', this.video.currentTime());
            }
          }, 1000);
        }

        if (paused) {
          paused = false;
          this.$emit('event', { event: 'resume' });
        }
      });
      this.video.on('pause', () => {
        paused = true;
        this.$emit('event', { event: 'pause' });
      });
      this.video.on('seeked', () => {
        // console.log('Videojs seeked');
        clearTimeout(seekTimeout);
        seekTimeout = setTimeout(() => {
          this.$emit('event', { event: 'seek' });
        }, 1000);
      });
      this.video.on('seeking', () => {
        // console.log('Videojs seeking');
      });
      this.video.on('volumechange', () => {
        if (this.video.muted()) {
          this.$emit('muted', true);
          this.$emit('event', { event: 'muted' });
        } else {
          this.$emit('volume', video.volume);
        }
      });

      this.$emit('duration', false);
    },
    /**
     * Play video
     */
    async playVideo() {
      try {
        await this.video.play();
      } catch (e) {
        try {
          if (!this.video.muted()) {
            this.video.muted(true);
            this.playVideo();
            return;
          }
        } catch (eb) { /* Do nothing */ }
      }

      if (this.video.muted() || this.video.volume() === 0) {
        // console.log('Videojs started s muted');
      }
    },
    emitResize() {
      this.$emit('resize', {
        width: this.$el.offsetWidth,
        height: this.$el.offsetHeight,
      });
    },
  },
  data() {
    return {
      video: null,
      pingInterval: null,
      timeInterval: null,
      keyy: 0,
    };
  },
  mounted() {
    this.setup();
    new ResizeObserver(() => this.emitResize()).observe(this.$el);
  },
  beforeDestroy() {
    clearInterval(this.pingInterval);
    clearInterval(this.timeInterval);
    if (this.video) {
      this.video.dispose();
    }
    this.$store.dispatch('Player/updateCurrentTime', 0);
  },
};
</script>

<style lang="scss">
.streamify-video {
  position: relative;
  width: 100%;

  &.hide-time {
    .video-js .vjs-control-bar {
      .vjs-live-control, .vjs-time-control.vjs-current-time {
        display: none;
      }
    }
  }

  &:not(.playing) {
    .middle {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    .purchase-icon {
      color: white;
      margin-bottom: 20px;
      font-size: 64px;
    }

    &[data-orientation="portrait"] {
      padding-top: calc((100% * 16) / 9);
    }

    &[data-orientation="landscape"] {
      padding-top: calc((100% * 9) / 16);
    }
  }

  .video-js {
    line-height: 0;
    width: 100%;
    &.vjs-fluid {
      height: 100%;
    }

    &:hover {
      .vjs-big-play-button {
        border-color: rgba(255, 255, 255, 1);
        background-color: transparent;
        span.vjs-icon-placeholder::before {
          color: white;
        }
      }
    }

    video {
      width: 100%;
      &:hover {
        cursor: pointer;
      }
    }

    .vjs-error-display, .vjs-modal-dialog {
      z-index: 0;
    }

    .vjs-big-play-button {
      pointer-events: all;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      left: 50%;
      background-color: transparent;
      border-radius: 100%;
      height: 100px;
      width: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      border: 2px solid rgba(255, 255, 255, .5);
      // transition: all .3s !important;

      &:focus {
        background-color: transparent !important;
      }

      span.vjs-icon-placeholder::before {
        color: rgba(255, 255, 255, .5);
        content: "\e911";
        font-family: 'icomoon';
        font-size: 64px;
        position: relative;
        // transition: color .3s;
      }
    }

    &.vjs-has-started:not(.vjs-ended) {
      .vjs-big-play-button {
        display: none;
      }
    }

    .vjs-control-bar {
      background-color: transparent;
      height: 48px;

      &:before {
        background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.80) 100%);
        content: "";
        height: 128px;
        width: 100%;
        left: 0;
        bottom: 0;
        position: absolute;
        pointer-events: none;
      }

      button {
        align-items: center;
        justify-content: center;

        &:focus {
          text-shadow: none;
        }

        & > .vjs-icon-placeholder:before {
          position: relative;
        }
      }

      .vjs-slider {
        &:focus {
          text-shadow: none;
          box-shadow: none;
        }
      }

      .vjs-progress-control {
        order: 4;
      }

      .vjs-live-control, .vjs-seek-to-live-control {
        align-items: center;
        flex: none;
        order: 3;
      }

      .vjs-progress-control {
        padding-right: 10px;
        .vjs-progress-holder {
          font-size: 16px;
        }
        &:hover .vjs-progress-holder {
          font-size: 16px;
        }

        .vjs-play-progress {
          &:before {
            top: 2px;
            font-size: 16px;
          }
        }
      }

      .vjs-subs-caps-button {
        display: none;
      }

      .vjs-time-control.vjs-current-time {
        align-items: center;
        order: 2;
        display: flex;
      }

      .vjs-remaining-time.vjs-time-control.vjs-control {
        display: none;
        order: 2;
        align-items: center;
      }

      .vjs-picture-in-picture-control {
        display: none;
      }

      .vjs-play-control {
        order: 0;

        span::before {
          font-family: 'icomoon';
          font-size: 24px;
        }
        &.vjs-playing {
          span::before {
            content: "\e90e";
          }
        }
        &.vjs-paused {
          span::before {
            content: "\e911";
          }
        }
      }

      .vjs-fullscreen-control {
        order: 5;
        .vjs-icon-placeholder::before {
          font-family: 'icomoon';
          content: "\e90a";
          font-size: 24px;
        }
      }

      .vjs-volume-panel {
        order: 1;
      }

      .vjs-mute-control {
        span.vjs-icon-placeholder::before {
          font-family: 'icomoon';
          font-size: 24px;
        }

        &.vjs-vol-0 span.vjs-icon-placeholder::before {
          content: "\e93e";
        }

        &.vjs-vol-1 span.vjs-icon-placeholder::before {
          content: "\e93f";
        }
        &.vjs-vol-2 span.vjs-icon-placeholder::before {
          content: "\e940";
        }
        &.vjs-vol-3 span.vjs-icon-placeholder::before {
          content: "\e941";
        }
      }

      .vjs-volume-panel {
        display: flex;
        align-items: center;
      }

      .vjs-volume-control {
        .vjs-volume-bar {
          .vjs-volume-level::before {
            top: 1px;
            font-size: 14px;
          }
        }
      }
    }

    &.vjs-error {

      .vjs-loading-spinner {
        display: none;
      }

      .vjs-modal-dialog {
        background: rgba(0, 0, 0, 1);
        width: 100%;
        max-width: 450px;
        height: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        &:before {
          content: "";
        }

        .vjs-modal-dialog-content {
          position: relative;
          height: auto;
          width: auto;
          font-family: 'Inter';
        }
      }
    }
  }

  &.large {
    .vjs-control-bar {
      align-items: center;
      flex-wrap: wrap;
      height: auto;

      .vjs-progress-control {
        margin-bottom: 8px;
        order: -1;
        width: 100%;
      }
    }
  }
}
</style>
